$(window).scroll(function() {
  let scrollTop = $(window).scrollTop(); // スクロール上部の位置
  let areaTop = $(".target-area").offset().top; // 対象エリアの上部の位置
  let areaBottom = areaTop + $(".target-area").innerHeight(); // 対象エリアの下部の位置

  if (scrollTop > areaTop && scrollTop < areaBottom) {
    $("body").addClass("is-in"); // スクロールが対象エリアに入った場合
  } else {
    $("body").removeClass("is-in"); // スクロールが対象エリアから出ている場合
  }
});

$(function ($) {
  // var checkMobile = $('.js-checkMobile');
  // $(checkMobile).each(function () {
  //   var ua = navigator.userAgent;
  //   if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0) {
  //   } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
  //   } else {
  //     $(this).addClass("fade-in smooth");
  //   }
  // });

  var fadeIn = $('.fade-in');
  $(window).scroll(function () {
    $(fadeIn).each(function () {
      var offset = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > offset - windowHeight + 120) {
        $(this).addClass("scroll-in");
      }
    });
  });
});

var headerH = $("#header").outerHeight(true); //headerの高さを取得

//スクロール途中からヘッダーの高さを変化させるための設定を関数でまとめる
function FixedAnime() {
  //ヘッダーの高さを取得
  var scroll = $(window).scrollTop();
  if (scroll >= headerH){ //ヘッダーの高さを超えたら
  $('#header').addClass('HeightMin'); //#headerについているHeightMinというクラス名を付与
  }else{
    $('#header').removeClass('HeightMin');//HeightMinというクラス名を除去
  }
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

//リンク先のidまでスムーススクロール
//※ページ内リンクを行わない場合は不必要なので削除してください
$('#g-navi li a').click(function () {
  var headerVal = $("#header").outerHeight(true); //現在のheaderの高さを取得

  //ヘッダーが高さの状態を取得してスクロールする範囲を調整する
  var scroll = $(window).scrollTop(); //スクロール
  var adjust = 0            //調整の変数
  if(scroll <= headerVal ){     //スクロールとヘッダーの高さを取得
    adjust = 70;          //スクロール値がヘッダーの高さ以内であれば調整変数に70を入れる
  }

  var elmHash = $(this).attr('href'); //hrefを取得
  var pos = $(elmHash).offset().top-headerVal-adjust; //クリックしたheader分の高さと調整分を引いた高さまでスクロール

  $('body,html').animate({scrollTop: pos}, 1000);
  return false;
});